import {
  createSlice,
  createAsyncThunk,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
import http from "../../utils/axios";

export const fetchStates = createAsyncThunk("public/fetchStates", async () => {
  const res = await http.get("/public/states");
  return res.data;
});

export const fetchCategories = createAsyncThunk(
  "public/fetchCategories",
  async () => {
    const res = await http.get("/public/categories");
    return res.data;
  }
);

export const fetchSubscriptionPackages = createAsyncThunk(
  "public/fetchsubscriptionPackages",
  async () => {
    const res = await http.get("/public/subscription-packages");
    return res.data;
  }
);

export const fetchDistrictsByState = createAsyncThunk(
  "public/fetchDistrictsByState",
  async (stateId) => {
    const res = await http.get(`/public/states/${stateId}/districts`);
    return res.data;
  }
);

export const fetchTalukasByDistrict = createAsyncThunk(
  "public/fetchTalukasByDistrict",
  async (districtId) => {
    const res = await http.get(`/public/districts/${districtId}/talukas`);
    return res.data;
  }
);

export const fetchSubcategoriesByCategory = createAsyncThunk(
  "public/fetchSubcategoriesByCategory",
  async (slug) => {
    const res = await http.get(`/public/categories/${slug}/sub-categories`);
    return res.data;
  }
);

export const fetchServicesByCategory = createAsyncThunk(
  "public/fetchServicesByCategory",
  async (slug) => {
    const res = await http.get(`/public/categories/${slug}/services`);
    return res.data;
  }
);

export const fetchPaymentModes = createAsyncThunk(
  "public/fetchPaymentModes",
  async () => {
    // Fetch only active payment modes for public use
    const res = await http.get("/dashboard/payment-modes?per_page=100");
    // API returns { success, message, data: [...], pagination }
    // Extract just the data array
    return res?.data || [];
  }
);

const commonApiSlice = createSlice({
  name: "common",
  initialState: {
    states: [],
    districts: [],
    categories: [],
    subcategories: [],
    talukas: [],
    subscriptionPackages: [],
    categoryServices: [],
    paymentModes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStates.fulfilled, (state, action) => {
        state.loading = false;
        state.states = action.payload;
      })
      .addCase(fetchStates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
      })

      .addCase(fetchSubscriptionPackages.fulfilled, (state, action) => {
        state.subscriptionPackages = action.payload;
      })
      .addCase(fetchDistrictsByState.fulfilled, (state, action) => {
        state.districts = action.payload;
      })

      .addCase(fetchSubcategoriesByCategory.fulfilled, (state, action) => {
        state.subcategories = action.payload;
      })
      .addCase(fetchServicesByCategory.fulfilled, (state, action) => {
        state.categoryServices = action.payload;
      })
      .addCase(fetchTalukasByDistrict.fulfilled, (state, action) => {
        state.talukas = action.payload;
      })
      .addCase(fetchPaymentModes.fulfilled, (state, action) => {
        state.paymentModes = action.payload || [];
      })

      .addMatcher(isPending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addMatcher(isFulfilled, (state) => {
        state.loading = false;
      })
      .addMatcher(isRejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default commonApiSlice.reducer;
